import { GraphApiService } from '@nuso/common/data-access-api';
import { Injectable, inject } from '@angular/core';
import {
  addIamAppUsersToGroupMutation,
  removeIamAppUsersFromGroupMutation,
  updateIamGroupMembershipMutation,
  addIamGroupToAppUsersMutation,
  removeIamGroupFromAppUsersMutation,
  updateIamGroupMembershipAndSetSupervisorMutation,
} from './iam-group-membership.queries';
import {
  CreateGroupMembershipInput,
  DeleteGroupMembershipInput,
  UpdateGroupMembershipInput,
} from '@nuso/iam/types';

@Injectable({
  providedIn: 'root',
})
export class IamGroupMembershipService {
  private graphApi = inject(GraphApiService);


  addAppUsersToGroup({
    groupId,
    appUserMembers,
  }: CreateGroupMembershipInput) {
    return this.graphApi.mutate({
      mutation: addIamAppUsersToGroupMutation,
      variables: {
        input: {
          groupId,
          appUserMembers,
        },
      },
    });
  }

  addGroupToAppUsers({
    groupId,
    appUserMembers,
  }: CreateGroupMembershipInput) {
    return this.graphApi.mutate({
      mutation: addIamGroupToAppUsersMutation,
      variables: {
        input: {
          groupId,
          appUserMembers,
        },
      },
    });
  }

  updateGroupMembership({
    groupId,
    appUserId,
    membershipType,
  }: UpdateGroupMembershipInput) {
    return this.graphApi.mutate({
      mutation: updateIamGroupMembershipMutation,
      variables: {
        input: {
          groupId,
          appUserId,
          membershipType,
        },
      },
    });
  }

  updateGroupMembershipAndSetSupervisor({
    groupId,
    appUserId,
    membershipType,
  }: UpdateGroupMembershipInput) {
    return this.graphApi.mutate({
      mutation: updateIamGroupMembershipAndSetSupervisorMutation,
      variables: {
        input: {
          groupId,
          appUserId,
          membershipType,
        },
      },
    });
  }

  removeAppUsersFromGroup({
    groupId,
    appUserId,
  }: DeleteGroupMembershipInput) {
    return this.graphApi.mutate({
      mutation: removeIamAppUsersFromGroupMutation,
      variables: {
        input: {
          groupId,
          appUserId,
        },
      },
    });
  }

  removeGroupFromAppUsers({
    groupId,
    appUserId,
  }: DeleteGroupMembershipInput) {
    return this.graphApi.mutate({
      mutation: removeIamGroupFromAppUsersMutation,
      variables: {
        input: {
          groupId,
          appUserId,
        },
      },
    });
  }
}
